module.exports = __webpack_public_path__ + "static/media/uploadBack.bb77794a.svg";